﻿export class Lazy<T> {
    private resolved: boolean;
    private resolvedValue: T;

    constructor(private lambda: () => T) { }

    value() {
        if (!this.resolved) {
            this.resolvedValue = this.lambda();
            this.lambda = null;
            this.resolved = true;
        }

        return this.resolvedValue;
    }

    isValueCreated() {
        return this.resolved;
    }
}